import React, { useState } from "react";
import { 
  Modal, 
  Form, 
  Button, 
  Space, 
  Typography,
  Alert,
  Upload,
  message,
} from "@pankod/refine-antd";
import { InboxOutlined } from "@ant-design/icons";
import { IWorkPlan } from "interfaces/work-plan.interface";

const { Dragger } = Upload;
const { Text } = Typography;

interface WorkPlanEvidenceModalProps {
  visible: boolean;
  onCancel: () => void;
  onUpload: (file: File) => void;
  workPlan?: IWorkPlan;
  isLoading?: boolean;
}

export const WorkPlanEvidenceModal: React.FC<WorkPlanEvidenceModalProps> = ({
  visible,
  onCancel,
  onUpload,
  workPlan,
  isLoading = false,
}) => {
  const [form] = Form.useForm();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleUpload = async () => {
    if (!selectedFile) {
      message.error('Por favor selecciona un archivo PDF');
      return;
    }

    onUpload(selectedFile);
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedFile(null);
    onCancel();
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.pdf',
    beforeUpload: (file: File) => {
      const isPdf = file.type === 'application/pdf';
      if (!isPdf) {
        message.error('Solo se permiten archivos PDF');
        return false;
      }
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error('El archivo debe ser menor a 10MB');
        return false;
      }

      setSelectedFile(file);
      return false; // Prevent automatic upload
    },
    onRemove: () => {
      setSelectedFile(null);
    },
    fileList: selectedFile ? [{
      uid: '1',
      name: selectedFile.name,
      status: 'done' as const,
    }] : [],
  };

  return (
    <Modal
      title="Subir Evidencia"
      visible={visible}
      onCancel={handleCancel}
      width={600}
      footer={null}
      destroyOnClose
    >
      {workPlan && (
        <div>
          <Alert
            message={`ID: ${workPlan.id} - ${workPlan.strategy}`}
            type="info"
            showIcon
            style={{ marginBottom: 24 }}
          />

          <Form form={form} layout="vertical">
            <Form.Item
              label="Archivo de evidencia (PDF)"
              help="Selecciona un archivo PDF que contenga la evidencia de la ejecución de esta actividad"
            >
              <Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Haz clic o arrastra un archivo PDF aquí
                </p>
                <p className="ant-upload-hint">
                  Solo archivos PDF. Tamaño máximo: 10MB
                </p>
              </Dragger>
            </Form.Item>
          </Form>

          <Space style={{ width: '100%', justifyContent: 'flex-end', marginTop: 16 }}>
            <Button onClick={handleCancel}>
              Cancelar
            </Button>
            <Button 
              type="primary" 
              onClick={handleUpload}
              loading={isLoading}
              disabled={!selectedFile}
            >
              Subir Evidencia
            </Button>
          </Space>
        </div>
      )}
    </Modal>
  );
};
